var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{show: _vm.isOffline},attrs:{"id":"offlineBar"}},[_c('svgicon',{attrs:{"src":"icons/wifi-offline.svg","width":26,"height":20}}),_c('div',{staticClass:"offline__text"},[_vm._v(_vm._s(_vm.$t('offline.bar')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }